import { Button } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const StyledButtonClose = styled(Button)`
  && {
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: ${rem(16)};
    top: ${rem(16)};
  }
`;

export default StyledButtonClose;
